import { lazyWithRetry } from 'utils/lazyWithRetry';
const ResetPasswordSuccess = lazyWithRetry(
  () => import(/* webpackChunkName: "ResetPasswordSuccess" */ './ResetPasswordSuccess')
);
export default ResetPasswordSuccess;
